import {InteractiveSearchRequestParams, InteractiveSearchRequest, InteractiveSearchResponse} from "../Definitions";

const CACHE: {
    [url: string]: InteractiveSearchResponse;
} = {};

export const requestInteractiveSearchApi = (api: string): InteractiveSearchRequest =>
    (params: InteractiveSearchRequestParams) => {
        return new Promise<InteractiveSearchResponse|null>((resolve) => {
            const url = new URL(api);

            url.searchParams.append("query", JSON.stringify(params));

            if (CACHE[url.toString()]) {
                resolve(CACHE[url.toString()]);
            }

            (async () => {
                const response = await fetch(url.toString());

                if (response.status === 200) {
                    const data = await response.json() as InteractiveSearchResponse;
                    CACHE[url.toString()] = data;
                    resolve(data);
                }
                resolve(null);
            })();
        });
    };
